import {createContext,useContext} from 'react';

// Optional host-provided session metadata; no authentication or wallet implementation.
export const PlayerSessionContext=createContext<{id:string;name:string;signOut:()=>void}|null>(null);
export const usePlayerSession=()=>useContext(PlayerSessionContext);
